// extracted by mini-css-extract-plugin
export default {"button-area":"Board_button-area__naSQq","table":"Board_table__5pkoQ"};